import BlockSettingsSchema from '@plone/volto/components/manage/Blocks/Block/Schema';
import { defineMessages } from 'react-intl';

import Edit from './SubtitleEdit';
import View from './SubtitleView';

import iconSVG from './icons/subtitle.svg';

defineMessages({
  subtitle: {
    id: 'Content subtitle',
    defaultMessage: 'Content subtitle',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.subtitleBlock = {
    id: 'subtitleBlock',
    title: 'Content subtitle',
    group: 'text',
    icon: iconSVG,
    view: View,
    edit: Edit,
    schema: BlockSettingsSchema,
    restricted: ({ properties, block }) =>
      !('subtitle' in properties) ||
      properties.blocks_layout?.items?.find(
        (uid) => properties.blocks?.[uid]?.['@type'] === block.id,
      ),
    mostUsed: false,
    blockHasOwnFocusManagement: true,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
